
import { MessageBox } from 'element-ui';
/**
 * 初始化模块，this指向technology-topo.provider
 */
export default function () {
    console.log('初始化模块启用')
    //添加全局函数
    globalThis.reload = () => {
        window.location.reload()
    }
    globalThis.$alert = (_, param) => {
        // window.alert(param)
        MessageBox.confirm(param, '提示', {
            distinguishCancelAndClose: true,
            confirmButtonText: '刷新',
            cancelButtonText: '关闭'
          }).then(() => {
              window.location.reload()
          })
    }



    this.globalFunctions = ['reload', '$alert'];

    let pens = this.store.data.pens;
    const MQTT = this.proc.make('MQTT');
    const DPC = this.proc.make('DPC')

    const getProperty = (key) => {
        let hasArr = [];
        for (let i = 0, len = pens.length; i < len; i++) {
            if (pens[i].hasOwnProperty(key)) {
                hasArr.push(pens[i])
            }
        }
        return hasArr;
    }
    // 设置组件的online属性
    MQTT.on('online', (bool) => {
        let pen = getProperty('online')
        if (pen.length) {
            // 更新组件属性上的在线信息
            pen.forEach(item => {
                this.stageCanvas.setValue({
                    id: item.id,
                    online: bool
                })
            })

        }
    })

    const setCtrlMode = (val) => {
        let pen = getProperty('controllerMode')
        this.update(val)
        if (!pen.length) return;
        val.map(mode => {
            return {
                id: mode.id,
                dataKey: mode.dataKey,
                value: mode.defineFormat[mode.currentValue],
                name: mode.name
            }
        }).forEach(mode => {
            pen.forEach(item => {
                this.stageCanvas.setValue({
                    id: item.id,
                    _controllerMode: mode,
                    CtrlMode: mode.value,
                    CtrlKey: mode.dataKey,
                })
            })
        })
    }
    

    // 控制模式
    let ctrlMode = DPC.ctrlMode;
    setCtrlMode(ctrlMode)
    this.proc.watch('ctrlMode', (val) => {
        setCtrlMode(val)
    })




}
